import {
  GLU_GET_CAMPAIGN_STATUS_FAILURE,
  GLU_GET_CAMPAIGN_STATUS_REQUEST,
  GLU_GET_CAMPAIGN_STATUS_SUCCESS,
} from "../../../Redux/Actions/GLUActions";
import { GLU_CampaignStatus } from "../types";

type State = {
  campaignStatus: GLU_CampaignStatus,
  isLoading: boolean,
  error: string,
};

const initialState: State = {
  campaignStatus: {} as GLU_CampaignStatus,
  isLoading: false,
  error: "",
};

export const campaignStatusReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GLU_GET_CAMPAIGN_STATUS_REQUEST:
      return {
        campaignStatus: {},
        isLoading: true,
        error: "",
      } as State;
    case GLU_GET_CAMPAIGN_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        campaignStatus: action.payload,
      } as State;
    case GLU_GET_CAMPAIGN_STATUS_FAILURE:
      return {
        campaignStatus: {},
        isLoading: false,
        error: action.payload,
      } as State;
    default:
      return state;
  }
};
